export class StringHelper {

  public static padZero(num: number, zeroLength: number = 2): string {
    return ('0'.repeat(zeroLength) + num).slice(-zeroLength);
  }

}
